// export const ENDPOINT = "http://localhost:80";
export const ENDPOINT = "https://api.almashhad.tk";
